<template>
  <div>
    
    <b-card class="px-2">

      <b-row>
        <b-col class="d-flex justify-content-end">
          <b-button 
            v-if="authV"
            class="btn btn-success" 
            @click="onShowModalCreate()"
          >Crear</b-button>
          <b-button
            class="ml-1"
            variant="success"
            size="sm"
            @click="descargarInsumosExcel"
            v-b-tooltip.hover
            title="Descargar cartera Insumos"
          >
          <i class="fas fa-file-excel"></i>
        </b-button>  
        </b-col>
      </b-row>

      <hr>

      <b-row class="mt-2">
        <b-form-input
          v-model="consultarinsumo"
          placeholder="Buscar por nombre del insumo"
          type="text"
          class="d-inline-block col-lg-6"
        />

        <!-- <v-select
          id="establecimiento"
          v-model="consultarestablecimiento"
          placeholder="Buscar por establecimiento."
          :options="establecimientos"
          :reduce="option => option.value"
          label="text"
          class="d-inline-block col-3"
        /> -->

        <b-button variant="primary" @click="buscarinsumo" class="col-2">
          <font-awesome-icon icon="magnifying-glass" style="color: white;"  /> 
          <span style="color: white;">buscar</span>
        </b-button>
      </b-row>
    </b-card>
    

    <b-overlay
      :show="mostrarLoader"
      opacity="0.50"
      rounded="sm"
    >
      <b-card class="principal">
        <b-col
          cols="12"
          class="pr-0 pl-0 mt-2"
        >
          <b-table
            v-if="items.length > 0"
            bordered
            striped
            responsive
            :per-page="perPage"
            :current-page="currentPage"
            :items="items"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template #cell(estadoJson)="data">
              <div class="row">
                <div class="col"> 
                  <span class="row">
                  <label>Iess:</label><label :class="data.item.estadoJson.iess ? 'text-success' : 'text-danger'">{{ data.item.estadoJson.iess ? 'Activo' : 'Inactivo' }}</label>
                  </span>
                  <span class="row">
                  <label>Issfa:</label><label :class="data.item.estadoJson.issfa ? 'text-success' : 'text-danger'">{{ data.item.estadoJson.issfa ? 'Activo' : 'Inactivo' }}</label>
                  </span>               
                  <span class="row">
                  <label>Isspol:</label><label :class="data.item.estadoJson.isspol ? 'text-success' : 'text-danger'">{{ data.item.estadoJson.isspol ? 'Activo' : 'Inactivo' }}</label>
                  </span>
                  <span class="row">
                  <label>Particular:</label><label :class="data.item.estadoJson.particular ? 'text-success' : 'text-danger'">{{ data.item.estadoJson.particular ? 'Activo' : 'Inactivo' }}</label>
                  </span>
                </div>
              </div>
            </template>
            <template #cell(precioJson)="data">              
              <div class="row">
                <div class="col"> 
                  <span class="row">
                  <label>Iess:</label><label class="text-primary">{{ data.item.precioJson.iess_n1}}</label>
                  </span>
                  <span class="row">
                  <label>Issfa N1:</label><label class="text-primary">{{ data.item.precioJson.issfa_n1}}</label>
                  </span>   
                </div>
                <div class="col">            
                  <span class="row">
                  <label>Issfa N2:</label><label class="text-primary">{{ data.item.precioJson.issfa_n2}}</label>

                  </span>
                  <span class="row">
                  <label>Particular:</label><label class="text-primary">{{ data.item.precioJson.particular}}</label>
                  </span>
                </div>
                <div class="col"> 
               
                  <span class="row">
                  <label>Isspol:</label><label class="text-primary">{{ data.item.precioJson.isspol_n1}}</label>

                  </span>   
                </div>
              </div>
            </template>
            <template #cell(acciones)="data">
              <div class="d-flex justify-content-center">

                <!-- <b-button v-if="authV" variant="info" size="sm" @click="viewItem(data.item.tokeninsumo)">
                  <font-awesome-icon icon="magnifying-glass" style="color: white;" />
                </b-button> -->
                <b-button v-if="authV" variant="primary" size="sm" @click="onShowModalEdit(data.item.tokeninsumo)">
                  <i class="fa-solid fa-pencil"></i>
                </b-button>
                <!-- <b-button v-if="authV" variant="danger" size="sm" @click="removeItemid(data.item.idinsumo)">
                  <font-awesome-icon icon="circle-xmark" style="color: white;" />
                </b-button> -->
              </div>
            </template>
          </b-table>
          <div v-else class="text-center">
            <p>No se encontraron registros</p>
          </div>
        </b-col>

        <b-col
          cols="12"
          class="mb-2"
        >
          <b-pagination
            v-if="items.length > 0"
            v-model="currentPageModificado"
            :total-rows="totalRows"
            :per-page="perPage"
            :small="true"
            first-number
            last-number
            class="mb-0"
            align="center"
            prev-class="prev-item"
            next-class="next-item"
            @change="cambiarPagina"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </b-col>
      </b-card>
    </b-overlay>
    <b-modal id="modal-ver-insumo" title="Detalles del insumo" size="md">
      <Verinsumo :token="tokenSeleccionado"/>
    </b-modal>

    <CrearInsumo :isVisible.sync="showModalCreate"/>
    <EditarInsumo 
      :isVisible.sync="showModalEdit" 
      :tokenInsumo="tokenInsumoEdit"
    />

  </div>
    
</template>

<script>

import { BootstrapVue }  from 'bootstrap-vue';
import actions from '@/assets/utils/utils'
import vSelect from 'vue-select'
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json'
import Verinsumo from './Verinsumo.vue';

import CrearInsumo from './CrearInsumo.vue';
import EditarInsumo from './EditarInsumo.vue';

export default {
  components: {
    ...BootstrapVue.components,
    vSelect,
    Verinsumo,
    CrearInsumo,
    EditarInsumo
  },
  data() {
        
    return {

      showModalCreate: false,
      showModalEdit:false,
      tokenInsumoEdit: null,

      tokenSeleccionado: null,
      modalShow: false,
      componenteDinamico: null,
      pagina_actual:1,
      currentPage: 1,
      currentPageModificado:1,
      mostrarLoader: false,
      login_user: '',
      consultarinsumo:null,
      consultarestablecimiento:'',
      establecimientos: [],
      establecimiento:'',
      perPage: 15,
      pageOptions: [3, 5, 10],
      totalRows: 3,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      fields: [
        { key: 'estadoJson', label: 'Activo/Inactivo', sortable: true, thClass: 'text-center' }, 
        { key: 'nombre', label: 'Nombre', sortable: true, thClass: 'text-center' },
        { key: 'precioJson', label: 'Precio', sortable: true, thClass: 'text-center' },
        { key: 'acciones', label: 'acciones', sortable: true, thClass: 'text-center', tdClass: 'text-center' },            
      ],

      listaAcciones: [],
      token_usuario: '',
      configdateTimePicker: {
        enableTime: false,
        dateFormat: 'd/m/Y',
      },

      items: [],
      descripcion: '',
      authV : false,
      codG: [
                '0000000001', '0000000013', '0000000012','0000000017', '0000000018', '0000000019', '0000000020'
            ]
    }
  },

  created() {
    this.comprobarPermisos()
    this.obtenerUserDetails()
    this.fetchConsultarinsumo()
    this.setToken();
    this.fetchEstablecimientos();
  },

  mounted() {
    actions.setearTitulo('Insumos')
  },

  methods: {
    async obtenerUserDetails(){
      let user= JSON.parse(localStorage.getItem('detalleusuario'))
                    
        user.roles.forEach(i => {
            if (this.codG.includes(i.codigo)) {
                
                this.authV = true
            }
        });
    },

    onShowModalCreate(){
      this.showModalCreate = true;
    },

    onShowModalEdit( tokenInsumo ){
      this.showModalEdit = true;
      this.tokenInsumoEdit = tokenInsumo;
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
    },

    cambiarPagina(paginaActual) {
      this.currentPage = paginaActual;
      const establecimientoValue = this.consultarestablecimiento ? this.consultarestablecimiento.toString() : '';
      this.fetchConsultarinsumo(this.consultarinsumo ? this.consultarinsumo : '', this.currentPage, establecimientoValue, this.perPage);
    },

    async fetchEstablecimientos() {
      const query = `
        query {
          allEstablecimientos {
            id
            Descripcion
            uniCodigo
          }
        }
      `;
      try {
        const response = await axios.post(rutas.axios + 'api', { query });
        this.establecimientos = response.data.data.allEstablecimientos.map(item => ({
          value: item.id,
          text: item.Descripcion,
          uniCodigo: item.uniCodigo
        }));
      } catch (error) {
        console.error('An error occurred while fetching the options:', error);
      }
    },

    async descargarInsumosExcel() {
      const query = `
        query ObtenerCarteraInsumosExcel {
          obtenerCarteraInsumosExcel
      }
      `;
      try {


        const response = await axios.post(rutas.axios + 'api', { query });
        const blobExcel = response.data.data.obtenerCarteraInsumosExcel;

        if (!blobExcel) return;
                
        
        actions.cargarArchivos(blobExcel, "CarteraTotalInsumos.xlsx", "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64")

      } catch (error) {
        console.error('An error occurred while fetching the options:', error);
      }
    },



    convertTojson(jsonString){
      try {
        let json_variable = JSON.parse(jsonString)
        return json_variable
      } catch (error) {
        console.log("error json", error)
      }
    },

    async fetchConsultarinsumo(search = '', pagina_actual = 1, establecimiento = '', pageSize ) {

      const query = `
        query GetAllinsumos($search: String, $establecimiento: String, $page: Int, $pageSize: Int) {
          allInsumos(search: $search, establecimiento: $establecimiento, page: $page, pageSize: $pageSize) {
            total
            status
            message
            insumos {
              id
              token
              nombre
              codigo
              establecimiento {
                id
                Descripcion
              }
              usuarioCreador {
                id
                username
              }

              precioNeto
              precioTecho
              precioJson
              estadoJson
              numMax
            }
            pageInfo {
              currentPage
              totalPages
              hasNextPage
              hasPreviousPage
            }
          }
        }
        `;
      const var_consulta = {
        search: search,
        page: pagina_actual,
        pageSize: pageSize,
        establecimiento: establecimiento.toString()
      }

      try {
        const response = await axios.post(rutas.axios + 'api', { query, variables: var_consulta });

        if (response.status === 200) {
          if (response.data.data.allInsumos.status === 'Success') {
            if (response.data.data.allInsumos.insumos) {
              let variable = response.data.data.allInsumos.insumos

              this.items = await response.data.data.allInsumos.insumos.map(item => {
                return {
                  idinsumo: item.id,
                  tokeninsumo: item.token,
                  establecimiento: item.establecimiento.Descripcion,
                  nombre: `${item.codigo} ${item.nombre}`,
                  codigo: item.codigo,
                  cantidad: item.numMax,
                  precioNeto: item.precioNeto,
                  precioJson: this.convertTojson(item.precioJson),
                  estadoJson: this.convertTojson(item.estadoJson),
                  usuario: item.usuarioCreador ? item.usuarioCreador.username : "No disponible"
                };
              });

              this.totalRows = response.data.data.allInsumos.total;
              this.currentPage = 1;
              this.currentPageModificado = pagina_actual
            } else {
              console.log("No se encontraron insumos");
            }
          } else {
            console.log("Error en la respuesta del servidor");
            // Manejo del error de respuesta del servidor
          }
        }
      } catch (error) {
        console.error("Error fetching insumos:", error);
      }
    },

    buscarinsumo() {
      const establecimientoValue = this.consultarestablecimiento ? this.consultarestablecimiento.toString() : '';
      this.fetchConsultarinsumo(this.consultarinsumo, this.currentPage, establecimientoValue, 15, '', '');
    },

    viewItem(tokeninsumo) {
      this.tokenSeleccionado = tokeninsumo;
      this.$bvModal.show("modal-ver-insumo");       
    },  

    removeItemid(idinsumo) {
      const mesa = this.fetchRemoveinsumo(idinsumo);
    },

    // async fetchRemoveinsumo(idinsumo) {
    //   this.$swal({
    //     title: 'Estas seguro de eliminar este insumo?',
    //     text: "No seras capaz de revertir esto!",
    //     icon: 'warning',
    //     showCancelButton: true,
    //     confirmButtonColor: '#3085d6',
    //     cancelButtonColor: '#d33',
    //     confirmButtonText: 'Si, Borrar esto!',
    //     cancelButtonText: 'No, cancelar!'
    //   }).then(async (result) => {
    //     if (result.isConfirmed) {
    //       try {
    //         const argFarm = {
    //           idinsumo: parseInt(idinsumo),
    //           datos: {
    //             estado: '0',
    //           },
    //         }

    //         const response = await axios.post(rutas.axios + 'api', {
    //           query: `
    //             mutation Actualizarinsumo($idinsumo: Int!, $datos: InsumoInput!) {
    //               actualizarInsumo(insumoDatos: { id: $idinsumo, datos: $datos }) {
    //                 insumoActualizado {
    //                   estado
    //                 }
    //                 message
    //                 status
    //               }
    //             } 
    //           `,
    //           variables: argFarm
    //         });

    //         if (response) {
    //           if (response.data.data.actualizarInsumo.status === "success") {
    //             if (response) {
    //               this.$swal({
    //                 title: 'Borrado!',
    //                 text: 'Tu registro ha sido eliminado',
    //                 icon: 'success',
    //                 confirmButtonColor: '#3085d6'
    //               }).then((result) => {
    //                 if (result.isConfirmed) {
    //                   this.$router.go(0);
    //                 }
    //               });
    //             }
    //             this.$router.push({ name: 'consultar_cartera_insumo' }).catch(err => {
    //               if (err.name !== 'NavigationDuplicated') {
    //                 console.error(err);
    //               }
    //             });
    //           } else {
    //             this.$swal({
    //               title: 'Error',
    //               text: response.data.data.actualizarInsumo.message,
    //               icon: 'error',
    //               confirmButtonColor: '#089599',
    //             })
    //           }
    //         }
    //       } catch (err) {
    //         console.log(err);
    //         return 'Error al eliminar doctor';
    //       }
    //     } else {
    //       this.$swal({
    //         title: 'Cancelado',
    //         text: 'Your registro esta seguro :)',
    //         icon: 'error',
    //         confirmButtonColor: '#3085d6'
    //       });
    //     }
    //   });
    // },

    setToken() {
      const user = JSON.parse(localStorage.getItem('usuario'))
      this.login_user = user.username
      axios.defaults.headers.common.Authorization = `JWT ${user.token}`
    },
        
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },

    comprobarPermisos() {
      if (localStorage.getItem('permisos').indexOf('consultar_cartera_farmaco') === -1) {
        this.$router.push({ name: 'not-permitted' })
      }
    },
  },
}
</script>
